import { Box, IconButton, Link } from "@mui/material";
import Grid2 from '@mui/material/Unstable_Grid2';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import LanguageIcon from '@mui/icons-material/Language';
import PhoneIcon from '@mui/icons-material/Phone';
import { useRestaurantData } from "../provider/RestaurantDataContext";


export default function RestaurantSocialMedia() {
    const { restaurantData: { socialMedia, address, qrMenuProperties } } = useRestaurantData();
    const iconSize = '1.5rem';

    const socialMedias = [
        { icon: <LanguageIcon />, link: socialMedia?.website, enabled: qrMenuProperties?.showWebsite },
        { icon: <PhoneIcon />, link: `tel:${address?.phoneNumber}`, enabled: qrMenuProperties?.showPhoneNumber },
        { icon: <YouTubeIcon />, link: socialMedia?.youtube, enabled: qrMenuProperties?.showYoutube },
        { icon: <InstagramIcon />, link: socialMedia?.instagram, enabled: qrMenuProperties?.showInstagram },
        { icon: <LinkedInIcon />, link: socialMedia?.linkedIn, enabled: qrMenuProperties?.showLinkedIn },
        { icon: <FacebookIcon />, link: socialMedia?.facebook, enabled: qrMenuProperties?.showFacebook },
    ];

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Grid2 container spacing={2}>
                {socialMedias.filter(socialMedia => socialMedia.enabled && (socialMedia.link?.length > 0 ?? false)).map((socialMedia, index) => (
                    <Grid2 xs key={index}>
                        <Link key={index} href={socialMedia.link} rel="noopener noreferrer" target="_blank">
                            <IconButton style={{ color: 'white', fontSize: iconSize }}>
                                {socialMedia.icon}
                            </IconButton>
                        </Link>
                    </Grid2>
                ))}
            </Grid2>
        </Box>
    );
}